<template>
	<main id="container" class="page-container">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="이벤트" />
				</div>
			</div>
		</div>
		<div class="page-content event-check event-eatingOut">
			<div class="container">
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물 받으세요.</h3>
				</div>
			</div>
			<div class="page-tab-container">
				<div class="container tab-buttons">
					<router-link to="eatingOut" class="tab-button is-active">외식 활성화</router-link>
					<router-link to="dineOut" class="tab-button">오늘 식사 한 끼, 밖에서 먹어요</router-link>
					<!-- <router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link>
					<router-link to="delivery" class="tab-button">공공배달앱 이용후기</router-link>
					<router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link> -->
				</div>
			</div>
			<div class="container">
				<div class="event-check-container">
					<div class="event-check-header">
						<div class="event-check-header-img">
							<div class="banner-img">
								<img src="@/assets/img/event/eventEating2025_0318.jpg" alt="EVENT 01 외식 활성화 이벤트" />
							</div>
						</div>
						<div class="event-check-header-info">
							<ul class="event-check-header-info-list">
								<li v-for="(item, idx) in infoList" :key="idx">
									<span class="infolist-title">{{ item.title }}</span>
									<span class="infolist-text">{{ item.detail }}</span>
								</li> 
								<li style="display: flex; align-items: flex-start; list-style: none; ">
									<span class="infolist-title ">{{ '진행방식' }}</span>
									<!-- 줄 바꿈을 해야하기 때문에 바인딩 하지않고 하드코딩으로 변경 -->
									<span class="infolist-text">골목상권 및 백년가게, 전통시장 식당 이용 후, SNS로 이용 후기 인증 및 네이버폼 접수
										<br>
										<br>골목상권 및 전통시장 확인처 : 전통시장통통 온누리상품권 가맹점포찾기
										<br><a href="https://www.sbiz.or.kr/sijangtong/nation/onnuri/onnuriMktList.do?menu_id=070400" target="_blank">https://www.sbiz.or.kr/sijangtong/nation/onnuri/onnuriMktList.do?menu_id=070400</a>
										<br>
										<br>백년가게 확인처 : 백년가게/소공인 홈페이지
										<br><a href="https://www.sbiz.or.kr/hdst/main/ohndMarketList.do" target="_blank">https://www.sbiz.or.kr/hdst/main/ohndMarketList.do</a>
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-guide">
						<span class="event-check-guide-title">참여방법</span>
						<div class="event-check-guide-desc no-border">
							<ul class="event-check-guide-desclist">
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e41.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 1</span>
										<span class="desclist-text">골목상권, 백년가게, 전통시장 식당에서 식사 또는 포장 주문</span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e42.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 2</span>
										<span class="desclist-text">SNS(인스타그램)에 방문 후기 업로드<br></span>
										<div class="desclist-tag">
											<span class="tag-title">인증미션</span>
											<div class="tag-item">
												<span>음식사진 1장, 매장 내·외부사진 1장, 후기 및 응원메시지(최소 20자)</span>
											</div>
										</div>
										<div class="desclist-tag">
											<span class="tag-title">필수태그</span>
											<div class="tag-item">
												<span>중소벤처기업부 인스타그램 (@mss.go.kr)</span>
											</div>
										</div>
										<div class="desclist-tag">
											<span class="tag-title">해시태그</span>
											<div class="tag-item">
												<span class="tag-desc">소상공인화이팅</span>
												<span class="tag-desc">전통시장화이팅</span>
												<span class="tag-desc">백년가게화이팅</span>
												<span class="tag-desc">2025동행축제</span>
											</div>
										</div>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e43.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 3</span>
										<span class="desclist-text">네이버폼에 SNS 게시글 링크와 필수 기재사항을 접수하면 응모가 완료 됩니다.</span>
										<div class="desclist-tag">
											<span class="tag-title">네이버폼</span>
											<div class="tag-item">
												<span>https://naver.me/5bV9JGrN</span><span class="accept-button"><a href="https://naver.me/5bV9JGrN" target="_blank">접수하기</a></span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-products">
						<span class="event-check-products-title">경품소개</span>
						<table class="my-table">
							<tbody>
							<tr>
								<th rowspan="4"><img :src="require(`@/assets/img/main/item_eating_1.jpg`)" /></th>
								<td><span>1등</span>  50만원권 (2명)</td>
							</tr>
							<tr>
								<td><span>2등</span> 10만원권 (10명)</td>
							</tr>
							<tr>
								<td><span>3등</span>  5만원권 (40명)</td>
							</tr>
							<tr>
								<td><span>4등</span>  1만원권 (100명)</td>
							</tr>
							</tbody>
						</table>
						<!-- <ul class="event-check-products-list">
							<li class="event-check-products-list-li" v-for="(item, idx) in prdList" :key="idx">
								<div class="event-check-products-item">
									<div class="event-check-products-item-img">
										<img :src="require(`@/assets/img/main/${item.img}`)" :alt="item.title" />
									</div>
									<div class="event-check-products-item-title">
										<span class="item-title-wrap">
											<span class="item-title">{{ item.title }}</span>
											<span class="item-title boldtxt">{{ item.person }}</span>
										</span>
									</div>
								</div>
							</li>
						</ul> -->
					</div>
				</div>
			</div>
			<div class="event-check-button-box">
				<div class="container flex-column">
					<span class="event-check-prect-title">경품발송</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in deliveryList" :key="idx">
							<span class="prect-list-text" v-html="item"></span>
						</li>
					</ul>
					
				</div>
			</div>

			<div class="into-area">
				<button type="button" v-if="isShowBtn" class="event-check-button" @click="clickLink('https://naver.me/5bV9JGrN')">참여하기</button>
				<!-- <span class="into-button"><a href="https://naver.me/5bV9JGrN" target="_blank">참여하기</a></span> -->
			</div>

			<div class="event-check-prect">
				<div class="container">
					<span class="event-check-prect-title">유의사항</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in prectList" :key="idx">
							<div class="prect-list-text" v-html="item" ></div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</main>
</template>

<style scoped>
.accept-button a{
	width: 80px; /* 버튼 너비 유지 */
  	height: 25px;  /* 버튼 높이 유지 */
	border-radius: 7px;
	display: inline-flex;
    background-color: #FDA5D0;    
    color: #ffffff;
    font-size: 17px;
    font-weight: 400;    
    justify-content: center;
    align-items: center;	
}
.into-area{
	text-align: center;
}
.into-button a{
	display: inline-flex;
    padding: 6px 12px;
    background-color: #FDA5D0;
    border-radius: 16px;
    color: #ffffff;
    font-size: 25px;
    font-weight: 700;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
	margin-top: 50px;	
}


.my-table {
  border-collapse: collapse; /* 셀 간 간격 제거 */
  width: 100%; /* 테이블 너비 설정 (선택 사항) */
  overflow: hidden; /* border-radius가 잘리는 것 방지 */
  margin-top: 30px;
  width: 52%; /* 표 너비 설정 */  
}

.my-table th,
.my-table td {
  border: 1px solid #ebebeb; /* 테두리 추가 */
  padding: 8px; /* 셀 안쪽 여백 */
  text-align: center; /* 텍스트 가운데 정렬 */
  width: 200px;
}

.my-table th {
  background-color: #ffffff; /* 제목 셀 배경색 */
}
.my-table span{
	font-weight: bold;
}
</style>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'EventEating',
	components: { PageHeader },
	data: () => ({
		visibleModal: false,
		infoList: [
			{
				title: '참여기간',
				detail: '2025년 3월 1일(토) ~ 2025년 3월 28일(금)',
			},
			{
				title: '결과발표',
				detail: '2025년 4월 중',
			},
			{
				title: '경품발송',
				detail: '2025년 5월 중',
			},
		],
		prdList: [
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 1만원',
				person: '(100명)',
			},
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 5만원',
				person: '(40명)',
			},
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 10만원',
				person: '(10명)',
			},
			{
				img: 'item_eating_1.jpg',
				title: '온누리상품권 50만원',
				person: '(2명)',
			},
		],
		deliveryList: ['이벤트 미션 완료자 대상으로 추첨을 통해 당첨자 선정', '5만원 이하 경품 : 네이버폼 접수 시 기재한 번호로 모바일 쿠폰 전송' , '5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내 및 개인정보 및 고유식별정보 수집·이용 및 제공 동의 → 제세공과금 납부 확인 후 네이버폼 접수 시 기재한 번호로 모바일 쿠폰 전송'],

		prectList: [
			'본 이벤트는 골목상권 및 백년가게, 전통시장 식당 이용 후, 개인 SNS(인스타그램) 계정에 필수 해시태그 및 응원메시지와 함께 게시물을 등록해 주신 후 홈페이지 이벤트 안내 페이지 내 [외식활성화 이벤트 참여] 버튼을 클릭하여 네이버폼에 접수해 주시면 응모가 완료됩니다.',
			'후기 인증 SNS 게시물은 당첨 시까지 유지해야 응모자 확인이 가능합니다.',
			'이벤트 참여 응모를 위한 네이버폼으로 취합 된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기 됩니다.',
			'지급 된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.',
			'당첨 쿠폰이 분실, 도난 된 경우, 재발송이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)',
			'5만원 초과 경품 당첨의 경우 제세공과금(22%)는 본인이 부담해야 합니다.',
			'당첨자는 이벤트 종료 후 1개월 이내 공지될 예정입니다.',
			'당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재 발송되지 않습니다.',
			'해당 이벤트에 만 14세 미만은 참여할 수 없습니다. <span style="color: Red;">(만 14세 미만 참여자의 경우 경품 당첨이 취소 됩니다.)',
			'이벤트 일정 및 경품내역은 추후 주최 측의 사정에 따라 변동 가능합니다.',
			'이벤트에 관한 문의는 대행사인 <span style="font-weight: bold;">㈜지엠컴 070-4838-6391</span>로 문의 바라며, 상담 가능 시간은 평일 오전 10시 ~ 오후 7시입니다.'
		],
		eventStart: false,
		mergedTitle: '제품 정보',
		content: ['사과', '바나나', '딸기', '포도'],
	}),
	computed: {
		isShowBtn() {
			return new Date() < new Date("2025-03-29 00:00:00")
		}
	},
	watch: {},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				const thisTab = document.querySelector('.tab-button.is-active');
				thisTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		});
	},
	methods: {
		clickEvent(e) {
			// let url = 'https://doit5.com/kshoppingfesta/direct?gc=a15';
			let url = 'https://doit5.com/kshoppingfesta/list.php';
			const w = 560;
			const h = 600;
			const title = '이벤트';

			// 브라우저 창의 크기 가져오기
			const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
			const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

			const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

			// 팝업창의 중앙 좌표 계산
			const left = width / 2 - w / 2 + dualScreenLeft;
			const top = height / 2 - h / 2 + dualScreenTop;

			// 팝업창 설정
			const options = `
				scrollbars=yes,
				width=${w}, 
				height=${h}, 
				top=${top}, 
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, '');

			// 팝업창 열기
			const newWindow = window.open(url, title, options);

			// 팝업창이 차단되었는지 확인
			if (window.focus && newWindow) {
				newWindow.focus();
			}

			return newWindow;
		},
		clickLink(url) {
			window.open(url, '_blank');
		},
	},
};
</script>
